let hideTimeout: ReturnType<typeof setTimeout> | null = null;

export function showSnackbar(message: string, duration = 5000): void {
  const container = document.getElementById('snackbar-container');
  if (!container) return;

  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }

  container.innerHTML = `<div class="snackbar snackbar-opened"><span class="snackbar-content">${message}</span></div>`;

  if (duration > 0) {
    hideTimeout = setTimeout(() => {
      hideSnackbar();
    }, duration);
  }
}

export function hideSnackbar(): void {
  const container = document.getElementById('snackbar-container');
  if (!container) return;
  container.innerHTML = '';
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }
}
